<a class="kr-logo" routerLink="/">
  <svg>
    <use
      [attr.xlink:href]="'assets/icons.svg#logo-crypto-banco'"
      [attr.href]="'assets/icons.svg#logo-crypto-banco'"></use>
  </svg>
</a>
